var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.875,
    y: 0.875,
    width: 56.0001,
    height: 56,
    rx: 28,
    stroke: "url(#paint0_linear_10132_136178)",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10132_136178",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 30,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8755 14.7292C34.2715 14.7294 38.6459 19.1037 38.646 24.4997C38.646 28.1238 36.6712 31.2846 33.7408 32.9714C34.8863 33.3289 35.9946 33.8116 37.0425 34.4167C39.5255 35.8505 41.5877 37.913 43.021 40.3962C43.3025 40.8842 43.1358 41.5088 42.648 41.7907C42.1599 42.0724 41.5355 41.9045 41.2535 41.4167C39.9993 39.2439 38.1946 37.4388 36.022 36.1842C33.8559 34.9335 31.399 34.2732 28.898 34.2692C28.8905 34.2692 28.883 34.2702 28.8755 34.2702C28.8679 34.2702 28.8597 34.2692 28.8521 34.2692C26.3512 34.2732 23.8951 34.9337 21.729 36.1842C19.5563 37.4388 17.7519 39.2438 16.4976 41.4167C16.2158 41.9046 15.5912 42.0722 15.1031 41.7907C14.6149 41.5088 14.4483 40.8844 14.73 40.3962C16.1635 37.9129 18.2254 35.8504 20.7085 34.4167C21.7561 33.8118 22.8633 33.3288 24.0083 32.9714C21.0783 31.2845 19.105 28.1234 19.105 24.4997C19.1052 19.1035 23.4794 14.7292 28.8755 14.7292ZM28.8755 16.7702C24.6069 16.7702 21.1462 20.2311 21.146 24.4997C21.146 28.7604 24.5934 32.2153 28.8511 32.2282H28.899C33.1567 32.2153 36.605 28.7604 36.605 24.4997C36.6048 20.2313 33.1439 16.7704 28.8755 16.7702Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10132_136178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.375 11.375H11.375V46.375H46.375V11.375Z",
    fill: "url(#paint1_linear_10132_136178)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10132_136178",
    x1: 28.875,
    y1: 0.875,
    x2: 28.875,
    y2: 56.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#786CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AFF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10132_136178",
    x1: 28.875,
    y1: 11.375,
    x2: 28.875,
    y2: 46.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#786CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AFF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.1e2ad509a7ac7abc55746b2dba1d81b4.svg";
export { ForwardRef as ReactComponent };